import React from 'react';

// import route Components here
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';

//pages
import Erro404Interno from '../errors/Erro404Interno';
import Dashboard from '../dashboard/Dashboard';
import Videos from '../videos/Videos';
import Financeiro from '../financeiro/Financeiro';
import Exercicios from '../exercicios/Exercicios';
import Blocos from '../blocos/Blocos';
import Campanhas from '../campanhas/Campanhas';
import Clientes from '../clientes/Clientes';
import Planos from '../planos/Planos';
import Relatorios from '../relatorios/Relatorios';
import PlanilhaTreino from '../planilha-treino/PlanilhaTreino';
import BlocosPlanilha from '../blocos-planilha/BlocosPlanilha';
import TreinoHome from '../treino-home/TreinoHome';
import PlanosAlimentares from '../planos-alimentares/PlanosAlimentares';
import PerguntasFrequentes from '../perguntas-frequentes/PerguntasFrequentes';
import TermosUso from '../termos-uso/TermosUso';
import Mensagens from '../mensagens/Mensagens';
import Usuarios from '../usuarios/Usuarios';
import Sobre from '../sobre/Sobre';
import Ebook from '../ebook/Ebook';
import TreinoDomiciliar from '../treino-domiciliar/TreinoDomiciliar';
import Politica from '../politica/Politica';
import Faq from '../faq/Faq';
import MenuIcon from "../../img/menu.svg";
import Header from '../header/Header';
import Menu from '../menu/Menu';

class AreaRestrita extends React.Component{
  constructor(props) {
      super(props);

      this.callMenu = this.callMenu.bind(this);
  }

  callMenu(e) {
    e.preventDefault();

    const menu = document.getElementById('menu');
    menu.classList.add("open");
  }

  render(){
    const match = this.props.match;

    return (
      <div className="area-restrita">
        <a href='#' className='button-menu' onClick={this.callMenu}><img src={MenuIcon} /></a>
        <Header />
        <Menu />
        <Route key={Math.random()} exact path={`${match.path}/dashboard`} component={Dashboard}/>
        <Route key={Math.random()} exact path={`${match.path}/videos`} component={Videos}/>
        <Route key={Math.random()} exact path={`${match.path}/planos-alimentares`} component={PlanosAlimentares}/>
        <Route key={Math.random()} exact path={`${match.path}/exercicios`} component={Exercicios}/>
        <Route key={Math.random()} exact path={`${match.path}/blocos`} component={Blocos}/>
        <Route key={Math.random()} exact path={`${match.path}/blocos-planilha`} component={BlocosPlanilha}/>
        <Route key={Math.random()} exact path={`${match.path}/planilhas-treino`} component={PlanilhaTreino}/>
        <Route key={Math.random()} exact path={`${match.path}/treino-domiciliar`} component={TreinoDomiciliar}/>
        <Route key={Math.random()} exact path={`${match.path}/treino-home`} component={TreinoHome} />
        <Route key={Math.random()} exact path={`${match.path}/clientes`} component={Clientes}/>
        <Route key={Math.random()} exact path={`${match.path}/campanhas`} component={Campanhas}/>
        <Route key={Math.random()} exact path={`${match.path}/planos`} component={Planos}/>
        <Route key={Math.random()} exact path={`${match.path}/financeiro`} component={Financeiro}/>
        <Route key={Math.random()} exact path={`${match.path}/usuarios`} component={Usuarios}/>
        <Route key={Math.random()} exact path={`${match.path}/relatorios`} component={Relatorios}/>
        <Route key={Math.random()} exact path={`${match.path}/perguntas-frequentes`} component={PerguntasFrequentes}/>
        <Route key={Math.random()} exact path={`${match.path}/politica-privacidade`} component={Politica} />
        <Route key={Math.random()} exact path={`${match.path}/termos-de-uso`} component={TermosUso} />
        <Route key={Math.random()} exact path={`${match.path}/sobre`} component={Sobre} />
        <Route key={Math.random()} exact path={`${match.path}/ebook`} component={Ebook} />
        <Route key={Math.random()} exact path={`${match.path}/faq`} component={Faq} />
        <Route key={Math.random()} exact path={`${match.path}/mensagens`} component={Mensagens} />
      </div>
    );
  }
}

export default AreaRestrita;



// WEBPACK FOOTER //
// ./src/classes/area-restrita/AreaRestrita.js